import type { SVGProps } from 'react';

const SettingsSliders = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.75 8H7.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.75 8H19.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.75 16H12.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.75 16H19.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 10.25C11.2426 10.25 12.25 9.24264 12.25 8C12.25 6.75736 11.2426 5.75 10 5.75C8.75736 5.75 7.75 6.75736 7.75 8C7.75 9.24264 8.75736 10.25 10 10.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 18.25C16.2426 18.25 17.25 17.2426 17.25 16C17.25 14.7574 16.2426 13.75 15 13.75C13.7574 13.75 12.75 14.7574 12.75 16C12.75 17.2426 13.7574 18.25 15 18.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SettingsSliders;
